export const getConstants = async () => {
  const response = await fetch(`/api/constants`);
  if (response.status === 204 || !response.ok) return null;
  const data = await response.json();
  return data;
};

export const getNetwork = async () => {
  const response = await fetch("/api/network");
  if (response.status === 204 || !response.ok) return null;
  const network = await response.json();
  return network;
};

export const getBackgrounds = async (campaign, artPack) => {
  const response = await fetch(
    `/api/artpack/${artPack}/background`
  );
  if (response.status === 204 || !response.ok) return campaign ? [] : null;
  const data = await response.json();
  if (campaign) {
    const bgpriceres = await fetch(`/api/campaign/${campaign}/backgroundprice`)
    if (bgpriceres.status === 204 || !bgpriceres.ok) return data;
    const { data: bgpricedata } = await bgpriceres.json()
    const resultarray = mergeArrays(data, bgpricedata)
    return resultarray;
  } else {
    return data;
  }

};

const mergeArrays = (arr1, arr2) => {
  return arr1.map(obj1 => ({
    ...obj1,
    ...(arr2.find(obj2 => obj2["rank"] === obj1["rank"]) || {})
  })).concat(arr2.filter(obj2 => !arr1.some(obj1 => obj1["rank"] === obj2["rank"])));
}

export const getPatterns = async (artPack) => {
  const response = await fetch(
    `/api/artpack/${artPack}/pattern`
  );
  if (response.status === 204 || !response.ok) return [];
  const data = await response.json();
  let pattern = []
  if (data) {
    pattern = await Promise.all(await data.map(async (item) => {
      if (item.arweave?.startsWith("http://") || item.arweave?.startsWith("https://")) {
        return { ...item, thumbnail_url: item.arweave }
      } else {
        const req = await fetch(`/api/file/name/${item.thumbnail_url}`);
        if (!req.ok) {
          throw new Error(`Failed to fetch image. Status: ${req.status}`);
        }

        const imgdata = await req.json();
        if (!imgdata?.image?.data) {
          throw new Error("Invalid image data received.");
        }

        const uint8Array = new Uint8Array(imgdata.image.data);
        let binaryString = '';
        for (let i = 0; i < uint8Array.length; i++) {
          binaryString += String.fromCharCode(uint8Array[i]);
        }

        return {
          ...item,
          thumbnail_url: `data:${imgdata.type};base64,${btoa(binaryString)}`,
        }
      }
    })
    )
  }
  return pattern;
};

export const getLayers = async (patternId) => {
  const response = await fetch(
    `/api/pattern/${patternId}/layer`
  );
  if (response.status === 204 || !response.ok) return [];
  const layers = await response.json();
  return layers;
};

export const getLayerChoices = async (layerId) => {
  const response = await fetch(
    `/api/layer/${layerId}/layerchoice`
  );
  if (response.status === 204 || !response.ok) return [];
  const data = await response.json();
  let layerChoices = []
  if (data) {
    layerChoices = await Promise.all(await data.map(async (item) => {
      if (item.layer_preview_url?.startsWith("http://") || item.layer_preview_url?.startsWith("https://")) {
        return { ...item }
      } else {
        const req = await fetch(`/api/file/name/${item.layer_preview_url}`);
        if (!req.ok) {
          throw new Error(`Failed to fetch image. Status: ${req.status}`);
        }

        const imgdata = await req.json();
        if (!imgdata?.image?.data) {
          throw new Error("Invalid image data received.");
        }

        const uint8Array = new Uint8Array(imgdata.image.data);
        let binaryString = '';
        for (let i = 0; i < uint8Array.length; i++) {
          binaryString += String.fromCharCode(uint8Array[i]);
        }

        return {
          ...item,
          thumbnail_url: `data:${imgdata.type};base64,${btoa(binaryString)}`,
        }
      }
    })
    )
  }
  return layerChoices;
};

export const getApprovedNames = async (artPack) => {
  const response = await fetch(
    `/api/artpack/${artPack}/approvedname`
  );
  if (response.status === 204 || !response.ok) return [];
  const data = await response.json();
  return data;
};

export const getPresetDistribution = async (campaignId) => {
  const response = await fetch(`/campaign/${campaignId}/presetdistribution`);
  if (response.status === 204 || !response.ok) return [];
  const data = await response.json();
  return data;
};

export const getRarityList = async (campaignId) => {
  const response = await fetch(`/api/campaign/${campaignId}/rarity`);
  if (response.status === 204 || !response.ok) return [];
  const data = await response.json();
  return data;
};

export const isApproved = async () => {
  const response = await fetch(`/campaign/approved`);
  if (response.status === 204 || !response.ok) return null;
  const data = await response.json();
  return data;
};

export const getCampaign = async () => {
  const response = await fetch(`/campaign`);
  if (response.status === 204 || !response.ok) return null;
  const data = await response.json();
  return data;
};

export const getCampaignDistribution = async (campaignDetails) => {
  const response = await fetch(`/campaign/distribution`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(campaignDetails),
  });
  if (response.status === 204 || !response.ok) return null;
  const data = await response.json();
  return data;
};

export const getFilterData = async (campaignDetails) => {
  const response = await fetch(
    `/artPack/${campaignDetails.artPackId}/getfilterData`
  );
  if (response.status === 204 || !response.ok) return null;
  const data = await response.json();
  return data;
};

export const getBuyNFT = (account, page, limit) => {
  const pagination = page && limit ? `?page=${page}&limit=${limit}` : "";
  const controller = new AbortController();
  const signal = controller.signal;
  const promise = new Promise(async (resolve) => {
    try {
      const response = await fetch(
        `/fundraisin/buy-nft/${account}${pagination}`,
        {
          method: "get",
          signal,
        }
      );
      if (response.status === 204 || !response.ok) {
        resolve(null);
        return;
      }
      const data = await response.json();
      resolve(data);
    } catch (error) {
      if (error && error.name === "AbortError") {
        console.log(`IGNORE: ${error.message}`);
      }
    }
  });
  promise.cancel = () => controller.abort();
  return promise;
};

export const getPreviewImage = (body) => {
  const controller = new AbortController();
  const signal = controller.signal;
  const promise = new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`/api/mintpreview/preview`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-type": "application/json",
        },
        signal,
      });
      const data = await response.text();
      resolve(data);
    } catch (error) {
      if (error && error.name === "AbortError") {
        console.log(`IGNORE: ${error.message}`);
        reject({});
      }
    }
  });
  promise.cancel = () => controller.abort();
  return promise;
};

export const getTokenOwner = async (tokenId) => {
  const response = await fetch(`/fundraisin/token/${tokenId}/owner`);
  const data = await response.text();
  return data;
};

export const getTopFundraiser = async (account) => {
  const response = await fetch(`/fundraisin/top-nft/${account}`);
  if (response.status === 204 || !response.ok) return [];
  const data = await response.json();
  return data;
};

export const getMyNFT = async (account) => {
  const response = await fetch(`/fundraisin/my-nft/${account}`);
  if (response.status === 204 || !response.ok) return [];
  const data = await response.json();
  return data;
};

export const getTotalMinted = async () => {
  const response = await fetch(`/fundraisin/totalminted`);
  if (response.status === 204 || !response.ok) return null;
  const data = await response.json();
  return data;
};

export const getCampaignById = async (account, id) => {
  const response = await fetch(`/api/sponsor/${account}/campaign/${id}`);
  if (response.status === 204 || !response.ok) return null;
  const data = await response.json();
  return data;
}

export const getArtPackById = async (account, id) => {
  const response = await fetch(`/api/artist/${account}/artpack/${id}`);
  if(response.ok){
    return await response.json();
  }
  return null;
}

export const LoadCheckMenu = async (userType, id, account) => {
  try {
    if (id) {
      const res = await fetch(
        `/api/${userType}/${id}/check-${userType}/${account}`
      );
      if (res.status === 200) {
        const json = await res.json();
        return json
      }
    }
  } catch (err) {
    console.error(err);
    return false;
  }
};

export const getArtPackApprovedStatus = async (item) => {
  if (!item.sc_id) return false;

  const response = await fetch(`/api/contract/artpack/${item.art_pack_id}/approved`);
  if (response.status === 204 || !response.ok) return false;
  const status = await response.text();

  return status === "true";
};